import { DataContext } from 'contexts/DataContextContainer'
import { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useUserBooksQuery } from 'store/queries'

function DashboardRedirect() {
  const history = useHistory()
  const { loggedInUser } = useContext(DataContext)
  const { data: userBooks } = useUserBooksQuery(loggedInUser?.id)

  useEffect(() => {
    if (userBooks?.length) {
      history.replace(`/dashboard/book/${userBooks[0].id}/info`)
    }
  }, [userBooks, history])
}

export default DashboardRedirect
